import { Schedule } from '../../models/schedule';
import { createStringIdAdapter } from './common/string-id-adapter';

export const scheduleAdapter = createStringIdAdapter<Schedule>();
